import { Box, Stack, TextField, Autocomplete } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";
import { GetReadOnlyInputProps } from "../../../../../HelperFunctions/HelperFunctions";

const COAPreference = ({ accountList }) => {
  const { values, setFieldValue } = useFormikContext();

  // Get selected values to disable in other dropdowns
 
  const Dropdown = ({
    label,
    value,
    options,
    getOptionLabel,
    isEqual,
    onChange,
    renderOption,
    disabledOptions = [],
  }) => {
    return (
      <Autocomplete
        size="small"
        disableClearable
        options={options}
        value={value}
        getOptionDisabled={(option) => option.ID === "select" || disabledOptions.includes(option.ID)}
        onChange={(e, newValue) => onChange(newValue)}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isEqual}
        sx={{ minWidth: 410 }}
        renderOption={renderOption}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="filled"
          />
        )}
      />
    );
  };

  const renderAccountOption = (props, option) => (
    <li {...props} style={{ width: "100%", padding: 0 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        p={0.5}
        // sx={{ px: 2, py: 1 }}
      >
        <span style={{ fontWeight: 400 }}>{option.Name}</span>
        <span
          style={{
            fontSize: "0.75rem",
            opacity: 0.7,
            color: "#666",
          }}
        >
          {option.AccountTypeName}
        </span>
      </Stack>
    </li>
  );

  return (
    <Stack height="100%" gap={3}>
      <Stack
        display={"flex"}
        width={"100%"}
        flexDirection={"column"}
        gap={4}
        alignItems={"center"}
        justifyContent="center"
      >
        <Dropdown
          label={
            <span>
             Chargebacks Adjustment account <span style={{ color: "red",fontSize:"18px" }}>*</span>
            </span>
          }
          value={
            accountList.find(
              (b) => b.ID === values.chargebacksAdjustmentAccount
            ) || accountList[0]
          }
          options={accountList}
          getOptionLabel={(o) => o.Name}
          isEqual={(o, v) => o.ID === v.ID}
          onChange={(val) =>
            setFieldValue("chargebacksAdjustmentAccount", val.ID)
          }
          renderOption={renderAccountOption}
         
        />
        <Dropdown
          label={
            <span>
              Fee Adjustment account <span style={{ color: "red",fontSize:"18px" }}>*</span>
            </span>
          }
          value={
            accountList.find((b) => b.ID === values.feeAdjustmentAccount) ||
            accountList[0]
          }
          options={accountList}
          getOptionLabel={(o) => o.Name}
          isEqual={(o, v) => o.ID === v.ID}
          onChange={(val) => setFieldValue("feeAdjustmentAccount", val.ID)}
          renderOption={renderAccountOption}
         
        />
        <Dropdown
          label={
            <span>
             Excess merchant account <span style={{ color: "red",fontSize:"18px" }}>*</span>
            </span>
          }
          value={
            accountList.find((b) => b.ID === values.excessMerchantAccount) ||
            accountList[0]
          }
          options={accountList}
          getOptionLabel={(o) => o.Name}
          isEqual={(o, v) => o.ID === v.ID}
          onChange={(val) => setFieldValue("excessMerchantAccount", val.ID)}
          renderOption={renderAccountOption}
       
        />
      </Stack>
    </Stack>
  );
};

export default COAPreference;
